class StoreFinderController {

    /*@ngInject*/
    constructor(storeFinderService, storefinder, $sce) {
        this.storeFinderService = storeFinderService;
        this.storefinder = storefinder;
        this.$sce = $sce;
    }
    
    $onInit() {
        this.branches = [];
        this.address = null;
        this.isSearchingForBranches = false;
        this.STORE_FINDER_SEARCH_RESULTS_LIMIT = this.storefinder.STORE_FINDER_SEARCH_RESULTS_LIMIT;
        this.trustAsHtml = this.$sce.trustAsHtml;
    }

    suburbAndPostcodeDisplayName(address) {

        return address.suburb + ' ' + address.postCode + ', ' + address.state;
    }

    getBranches(){

        var searchAddress = this.suburbAndPostcodeDisplayName(this.address);
        var _self = this;
        _self.isSearchingForBranches = true;

        this.storeFinderService.StoreFinderSearch(searchAddress, this.STORE_FINDER_SEARCH_RESULTS_LIMIT).then(
            function(result) {
                _self.isSearchingForBranches = true;
                _self.branches = result;
            }
        ).catch(function(error) {
            //console.log(error);
        }).then(function(){
            _self.isSearchingForBranches = false;
        });
    }

    setBranch(branch) {

        //  Data structure returned from service is different to what is being bound
        this.branch = {
            address: branch.address.address,
            branchName: branch.branchHtmlName.companyNameBranchLongNameHtml,
            branchNumber: branch.branchCode,
            postCode: branch.address.postcode,
            state: branch.address.state,
            suburb: branch.address.suburb,
            telephone: branch.phoneNumber
        };

        //  Reset the address and branches
        this.address = null;
        this.branches = [];
    }

    isDisabled() {

        if(this.address === null) {
            return true;
        }

        return false;
    }
}

export default StoreFinderController;


// WEBPACK FOOTER //
// ./src/app/common/storefinder/store-finder.controller.js